import {create} from "zustand";

//para almacenar el link generado
export interface payLinkMateria{
    hash: string;
}

// export interface paymentParams{
//     mp_account: string //process.env.REACT_APP_MP_ACCOUNT,
//     mp_product: string,
//     mp_order: string //order,
//     mp_reference: string //reference,
//     mp_node: string,
//     mp_concept: string,
//     mp_amount: string, //total.toFixed(2),
//     mp_currency: string,
//     mp_customername: string,
//     mp_hash?: string //hash,
//     mp_urlsuccess: string //`${process.env.REACT_APP_API_URL}/fines/payment-response`,
//     mp_urlfailure: string //`${process.env.REACT_APP_API_URL}/fines/payment-response`,
//     mp_boleta: string //objeto   fines[0].boleta.toString(),
// }

export interface paymentParams{
    s_transm: string,
    c_referencia: string,
    t_servicio: number,
    t_importe: number,
    val_1: string,
    val_2: string,
    val_3: string,
    mp_signature: string,
}

export interface payLinkProps{
    payLinkMateria: payLinkMateria | null; //payLinkMateria podria ser null
    noPayCase: (state: payLinkMateria) => void; //no devolvea nada
    removePayLink: () => void; //no devuelve nada
}
//state para almacenar los valores que crearan el url
export const payLinkStore = create<payLinkProps>((set) => ({
    payLinkMateria: { hash: "" },
    noPayCase: (state: payLinkMateria) =>
    set({
        payLinkMateria: state,

    }),
    removePayLink: () =>
        set({
            payLinkMateria: null,
    
        }),
}))


// Definir el estado global para paymentParams
interface PaymentStore {
    paymentData: string | null;
    setPaymentData: (data: string) => void;
}

export const usePaymentStore = create<PaymentStore>((set) => ({
    paymentData: null,
    setPaymentData: (data:string) => set({ paymentData: data }),
    removePayLink: () => set({ paymentData: null }),
}));
